const app = 'AVP';
const [RESOLVED_NAME, REJECTED_NAME] = ['_RESOLVED', '_REJECTED'];

export default function(module) {
  return action => `${app}/${module}/${action}`;
}

export const resolved = actionName => actionName + RESOLVED_NAME;
export const rejected = actionName => actionName + REJECTED_NAME;
